import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router"
import config from '../../config.json'
import { AD } from '../../constants/itemTypes'
import toJS from '../../hoc/toJS'
import { adsDeleteItem } from '../../actions'
import getData from '../../functions/getData'
import { AUTH_CAPS, PROGRAM_ADS_ITEMS } from '../../constants/state'
import ListDrag from '../../components/DragAndDropList/presents/ListDrag'
import dndItemTypes from '../../constants/dndItemTypes'
import ProgramDragDropItemSwitch from '../../components/PageEditSelection/ProgramDragDropItemSwitch'
import canEditProgram from '../../functions/canEditProgram'

const mapStateToProps = state => ({
    items: getData(state, PROGRAM_ADS_ITEMS),
    caps: getData(state, AUTH_CAPS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({    
    removeItem: (itemID) => {
        dispatch(adsDeleteItem(itemID))
    }
})

const ProgramListAdsContainer = ({ 
    titleTransId, 
    buttonTextTransId,
    className, 
    items,
    match, 
    caps,
    isAllOpen,
    setAllOpen,
    removeItem
}) => {
    const order = Object.keys(items)

    const basicUrl = `${config.routes.program.path}/${match.params.selectionType}/${match.params.selectionId}`
    const pathnameAdd = `${basicUrl}/${AD}/addItem/form`
    const canEdit = canEditProgram(caps)

    return <ListDrag
        titleTransId={titleTransId}
        buttonTextTransId={buttonTextTransId}
        listId={'ad-'  + match.params.selectionId}
        dndType={dndItemTypes.PROGRAM_ITEM_AD}
        className={className}

        type={AD}

        order={order}
        items={items}

        ChildSwitchItem={ProgramDragDropItemSwitch}

        params={false}
        basicUrl={basicUrl}

        defaultIsOpen={isAllOpen}
        setAllOpen={setAllOpen}

        canEdit={canEdit}
        canDelete={canEdit}
        pathnameAdd={pathnameAdd}
        deleteItem={removeItem}
    />
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(ProgramListAdsContainer)